import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, Row, Col, Card, Button } from "antd";
import moment from "moment";
import { Translate } from "react-translated";

class VirtualFollowUpCalls extends Component {
  state = {
    pending: false,
  };

  togglePending = () => {
    this.setState((prevState) => ({ pending: !prevState.pending }));
  };
  render() {
    const { dashboard, loading, period, start_date, end_date } = this.props;

    if (typeof dashboard.stats === "undefined") {
      dashboard.stats = {
        bfile_folow_up_not_completed_count: 0,
        bfile_folow_up_not_completed_count_due: 0,
      };
    }

    let date_url = "";
    if (period === "from_to") {
      date_url =
        "/all/" +
        encodeURIComponent(moment(start_date).format("MM/DD/YYYY")) +
        "/" +
        encodeURIComponent(moment(end_date).format("MM/DD/YYYY"));
    }
    if (period === "all_bfiles") {
      date_url = "?all_bfiles";
    }

    return (
      <div style={{ marginBottom: 20 }}>
        <Card
          title={
            <div>
              <Icon
                type="phone"
                style={{ marginRight: 10, color: "#1890ff" }}
              />
              <Translate text={`Virtual Follow Up Calls`} />
            </div>
          }
          className="onboarding-circle"
          loading={loading}
          bordered={false}
        >
          {this.state.pending ? (
            <div>
              <div className="chartVal">
                <Link
                  to={"/bfiles/virtual-follow-up-incompleted-calls" + date_url}
                >
                  {dashboard.stats.bfile_folow_up_not_completed_count}
                </Link>
              </div>
              <Button
                onClick={this.togglePending.bind(this)}
                // icon="clock-circle-o"
              >
                {" "}
                <Translate text={`Show Due Calls`} />
              </Button>
            </div>
          ) : (
            <div>
              <div className="chartVal" style={{ justifyContent: "center" }}>
                <Link
                  to={"/bfiles/virtual-follow-up-due-calls" + date_url}
                  style={{ textAlign: "center" }}
                >
                  {dashboard.stats.bfile_folow_up_not_completed_count_due}
                </Link>
              </div>
              <Button
                onClick={this.togglePending.bind(this)}
                // icon="close"
              >
                {" "}
                <Translate text={`Show Incomplete Calls`} />
              </Button>
            </div>
          )}
        </Card>
      </div>
    );
  }
}

export default VirtualFollowUpCalls;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/virtual-follow-up-calls.js